import { defineBlock, BlockWrapper, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import { lazy } from 'react';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector'));

const Anchor = ({ content, ListType, icon }) => {
    useInspectorControl(Inspector);
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.row}>
                <img src={icon.url} alt={icon.alt} />
                <EditableText tagName="span" smartProp="title" />
            </div>
            <ListType className={style.list}>
                {content.map((el, i) => {
                    const Tag = el.link ? 'a' : 'div';
                    const p = el.link ? { href: el.link } : {};

                    return ListType !== 'div' ? (
                        <li key={i}>
                            <Tag {...p}>{el.text}</Tag>
                        </li>
                    ) : (
                        <Tag key={i} {...p}>
                            {el.text}
                        </Tag>
                    );
                })}
            </ListType>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Anchor,
    smartProps: {
        title: smartProps.string.withDefault(''),
        content: smartProps.array.withDefault([]),
        ListType: smartProps.string.withDefault('div'),
        icon: smartProps.object.withDefault({}),
    },
    setup: {
        title: 'Ancre',
        parent: ['smartfire/anchor-text---anchor-part'],
    },
});
